import { Component } from "@angular/core";
import { VS_PEERS_TAB, COMPANY_TAB } from "../tpr-constants";
import { Subscription } from "rxjs";
import { ActivatedRoute } from "@angular/router";
import { Store } from "@ngrx/store";
import { AppState, stateGetter } from "src/app/store/state/app.state";
import { ValuationPageState } from "src/app/valuation-page/valuation-page.model";
import { DeleteDpParams } from "src/app/store/actions/global-subheader.actions";
import { LeftPanel } from "src/app/store/models/global.model";
import { AppService } from "src/app/app.service";
import { TPR_LOG_ACTION_FEATURES, TPR_PAGE } from "src/app/tpr/tpr-constants";
@Component({
  selector: "app-tpr",
  templateUrl: "./tpr.component.html",
  styleUrls: ["./tpr.component.scss"],
  host: { class: "tpr-page-component" },
})
export class TprComponent {
  //instance variables
  vsPeerTabTitle = VS_PEERS_TAB.label;
  companyTabTitle = COMPANY_TAB.label;
  selectedTabIndex = COMPANY_TAB.index;
  primaryTicker = "";
  urlTicker = ""; // need original ticker value, which can be in lowercase or uppercase
  showTprVsPeersTab: boolean;
  legacyUrl = `${window.caUrl}/home`;
  isPeerTabVisible = false;
  state: ValuationPageState = {
    vsPeerTab: {},
    companyTab: {},
    chartTab: {},
  };

  //subscribers
  routeParamSubscriber: Subscription;
  tprAccessSubscriber: Subscription;
  globalAppSettingSubscriber: Subscription;
  enablingVsPeerSubscriber: Subscription;

  constructor(
    private route: ActivatedRoute,
    private store: Store<AppState>,
    private appService: AppService,
  ) {}

  ngOnInit() {
    this.tprAccessSubscriber = this.store
      .select(stateGetter("globalHeader", "globalSettings"))
      .subscribe((data: any) => {
        if (data.restrictAccessToTprPage) {
          window.location.href = this.legacyUrl;
        }
      });
    this.routeParamSubscriber = this.route.params.subscribe((paramData) => {
      this.primaryTicker = paramData.ticker
        ? paramData.ticker.toUpperCase()
        : undefined;

      this.appService.logUserAction(
        {},
        this.primaryTicker,
        "",
        TPR_LOG_ACTION_FEATURES.visitPage,
        undefined,
        "",
        TPR_PAGE,
      );
      this.urlTicker = paramData.ticker;
    });

    this.globalAppSettingSubscriber = this.store
      .select(
        stateGetter("globalHeader", "globalAppSettings", "period_settings"),
      )
      .subscribe((data) => {
        if (data) {
          //raise update of state on the tabs to trigger data calls
          this.updatevsPeerTabData(this.state.vsPeerTab);
        }
      });
    this.enablingVsPeerSubscriber = this.store
      .select(stateGetter("leftPanel", "data"))
      .subscribe((data: LeftPanel) => {
        if (this.urlTicker in data) {
          this.showTprVsPeersTab =
            data[this.urlTicker]["data"] &&
            data[this.urlTicker]["data"][0]["values"]["showTprVsPeers"];
        } else {
          this.showTprVsPeersTab = false;
        }
      });
  }

  /**
   * It updates given property of vsPeers tab
   * @param {objet} obj: oject to update
   */
  updatevsPeerTabData(obj) {
    this.state.vsPeerTab = {
      ...this.state.vsPeerTab,
      ...obj,
    };
    this.store.dispatch(new DeleteDpParams());
  }

  ngOnDestroy() {
    if (this.routeParamSubscriber) {
      this.routeParamSubscriber.unsubscribe();
    }

    if (this.tprAccessSubscriber) {
      this.tprAccessSubscriber.unsubscribe();
    }

    if (this.globalAppSettingSubscriber) {
      this.globalAppSettingSubscriber.unsubscribe();
    }

    if (this.enablingVsPeerSubscriber) {
      this.enablingVsPeerSubscriber.unsubscribe();
    }
  }

  onTabChange(obj) {
    if (obj.index === 1) {
      this.isPeerTabVisible = true;
    } else {
      this.isPeerTabVisible = false;
    }
    this.appService.logUserAction(
      {},
      this.primaryTicker,
      "",
      obj.index === 1
        ? TPR_LOG_ACTION_FEATURES.peersTabSelection
        : TPR_LOG_ACTION_FEATURES.companyTabSelection,
      undefined,
      "",
      TPR_PAGE,
    );
    this.store.dispatch(new DeleteDpParams());
  }
}
